const defaultBtnClass =
  "px-2 py-1 rounded-[4px] bg-[#E6E7E8] text-[11px] font-inter-semibold text-[#808285]";
const activeBtnClass =
  "px-2 py-1 rounded-[4px] bg-white text-[11px] font-inter-semibold text-[#252526]";

const Tab = ({ onSelect, activeTab, disabled }) => {
  const _handleClickTab = (tab) => {
    onSelect(tab);
  };

  return (
    <div className="flex items-center rounded-[4px] justify-center p-0.5 bg-[#E6E7E8] w-fit">
      <button
        onClick={() => _handleClickTab("unprocessed")}
        disabled={disabled}
        className={activeTab === "unprocessed" ? activeBtnClass : defaultBtnClass}
      >
        Listing
      </button>
      <button
        onClick={() => _handleClickTab("processed")}
        disabled={disabled}
        className={activeTab === "processed" ? activeBtnClass : defaultBtnClass}
      >
        Dirapikan
      </button>
    </div>
  );
};

export default Tab;
